import { render, staticRenderFns } from "./WizardView.vue?vue&type=template&id=4f498d4a&"
import script from "./WizardView.vue?vue&type=script&lang=js&"
export * from "./WizardView.vue?vue&type=script&lang=js&"
import style0 from "@/assets/wizard-font/styles.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f498d4a')) {
      api.createRecord('4f498d4a', component.options)
    } else {
      api.reload('4f498d4a', component.options)
    }
    module.hot.accept("./WizardView.vue?vue&type=template&id=4f498d4a&", function () {
      api.rerender('4f498d4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wizard/WizardView.vue"
export default component.exports